// extracted by mini-css-extract-plugin
export default {"tags":"tags-module--tags--GHjwN","tag":"tags-module--tag--oL4mO","tooltip":"tags-module--tooltip--OMVED"};